import { Tooltip as RadixTooltip } from "radix-ui";
import type { ReactElement, ReactNode } from "react";

export type TooltipProps = {
  /** Already translated; also what a pointer user reads before pressing (the trigger keeps its own accessible name). */
  label: string;
  side?: "top" | "bottom";
  /**
   * A richer card instead of the one-line label (a status: emoji, text, "Until …"): the elevated surface, wraps.
   * `label` is then unused on web but still names it for native `.help`.
   */
  content?: ReactNode;
  /** Opening delay in ms (default: the `PrimitivesProvider` one). */
  delay?: number;
  /** The trigger: one Button / IconButton / Pressable / Chip (or a span that only hover reveals). */
  children: ReactElement;
};

/**
 * A short hint on hover or keyboard focus (web: Radix Tooltip, opening after the `PrimitivesProvider` delay). Never the
 * only place information lives: touch has no hover. Native: iOS `.help(label)`, Android `TooltipBox` + `PlainTooltip`.
 */
export function Tooltip({ label, side = "top", content, delay, children }: TooltipProps) {
  return (
    <RadixTooltip.Root delayDuration={delay}>
      <RadixTooltip.Trigger asChild>{children}</RadixTooltip.Trigger>
      <RadixTooltip.Portal>
        <RadixTooltip.Content className={content === undefined ? "b-tooltip" : "b-tooltip b-tooltip-card"} side={side} sideOffset={6} collisionPadding={8}>
          {content === undefined ? label : content}
        </RadixTooltip.Content>
      </RadixTooltip.Portal>
    </RadixTooltip.Root>
  );
}
